import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'

import { getUser } from '../lib/auth'

interface Props { children: React.ReactNode }

export default function ProtectedRoute({ children }: Props) {
  const [state, setState] = useState<'loading' | 'signed-in' | 'signed-out'>('loading')

  useEffect(() => {
    getUser().then(u => setState(u && !u.expired ? 'signed-in' : 'signed-out'))
  }, [])

  if (state === 'loading') return <div className="h-full grid place-items-center text-slate-500">Loading…</div>
  if (state === 'signed-out') return <Navigate to="/signin" replace />
  return <>{children}</>
}
